import { render, staticRenderFns } from "./LetterExampleSentenceDialog.vue?vue&type=template&id=c8e4107a"
import script from "./LetterExampleSentenceDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./LetterExampleSentenceDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LetterExampleSentenceDialog.vue?vue&type=style&index=0&id=c8e4107a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports